import React, { useState } from 'react';
import { Button } from '@thd-olt-component-react/button';
import { Overlay } from '@thd-olt-component-react/overlay';
import { LoadingPlaceholder } from '@thd-olt-component-react/loading-placeholder';
import { bool, string, shape } from 'prop-types';
import {
  arrayOf,
  params,
  shape as shapeType,
  string as stringType
} from '@thd-nucleus/data-sources';
import { SizeGuideOverlayContent } from './components/size-guide-overlay-content/size-guide-overlay-content';
import { publish } from './publisher';
import { useSizeGuide } from './useSizeGuide';
import './size-guide.scss';

export const SizeGuide = (props) => {
  const {
    itemId,
    isCollection,
    isSuperSku,
    productType,
    superSkuSizeAndFitDetail,
    itemSizeAndFitDetail,
    storeIdFromMock,
    channelFromMock
  } = props;

  const [open, setOpen] = useState(false);

  const { data: sizeGuideResponse, loading, error } = useSizeGuide({
    itemId, isCollection, isSuperSku, superSkuSizeAndFitDetail, itemSizeAndFitDetail, storeIdFromMock
  }) || {};

  if (error && !sizeGuideResponse) {
    return null;
  }
  if (loading) {
    return (
      <div style={{ width: '100px' }}>
        <LoadingPlaceholder
          type="text"
          ready={false}
          color="#E0E0E0"
          rows={1}
          showLoadingAnimation
        >
          Loading...
        </LoadingPlaceholder>
      </div>
    );
  }

  const handleSizeGuideClick = () => {
    setOpen(true);
    publish('size-guide.click', {});
  };

  const linkTitle = 'Size Guide';

  if (!sizeGuideResponse) {
    return null;
  }

  return (
    <div className="size-guide-wrapper">
      <Button
        link
        onClick={handleSizeGuideClick}
      >
        <span data-testid="size-guide-link">{linkTitle}</span>
        <span className="size-guide__info" data-testid="info-icon" />
      </Button>
      <Overlay
        closeButton
        medium
        open={open}
        onClose={() => setOpen(false)}
        header="Size Guide"
      >
        <SizeGuideOverlayContent
          productType={productType}
          sizeGuideResponse={sizeGuideResponse}
          channelFromMock={channelFromMock}
        />
      </Overlay>
    </div>
  );
};

SizeGuide.displayName = 'SizeGuide';

SizeGuide.propTypes = {
  channelFromMock: string,
  isCollection: bool,
  isSuperSku: bool,
  itemId: string.isRequired,
  itemSizeAndFitDetail: shape({}),
  productType: string,
  superSkuSizeAndFitDetail: shape({}),
  storeIdFromMock: string
};

SizeGuide.defaultProps = {
  channelFromMock: null,
  isCollection: false,
  isSuperSku: false,
  itemSizeAndFitDetail: {},
  productType: null,
  superSkuSizeAndFitDetail: {},
  storeIdFromMock: null
};

SizeGuide.dataModel = {
  product: params({ itemId: stringType().isRequired(), dataSource: stringType() }).shape({
    itemId: stringType(),
    dataSources: stringType(),
    sizeAndFitDetail: shapeType({
      attributeGroups: arrayOf(shapeType({
        dimensionLabel: stringType(),
        attributes: arrayOf(shapeType({
          attributeName: stringType(),
          dimensions: stringType()
        })),
        productType: stringType()
      }))
    })
  }),
  collection: params({ collectionId: stringType().isRequired(), storeId: stringType() }).shape({
    sizeAndFitDetail: shapeType({
      collectionName: stringType(),
      attributeGroups: arrayOf(shapeType({
        dimensionLabel: stringType(),
        attributes: arrayOf(shapeType({
          attributeName: stringType(),
          dimensions: stringType()
        })),
        productType: stringType()
      }))
    })
  })
};
